<template>
<div class="edu-records">
    <nav class="edu-record-breadcrumb" aria-label="页面位置"><router-link to="/home/index">首页</router-link><v-icon size="13">mdi-chevron-right</v-icon><span>教务中心</span><v-icon size="13">mdi-chevron-right</v-icon><span>请假管理</span></nav>
    <header class="edu-record-heading"><h1>请假管理</h1><p>集中查看请假申请与审核结果，及时安排学员的课程。</p></header><section class="edu-record-filters" aria-label="筛选请假申请"><div class="edu-record-filter-title"><h2>筛选请假申请</h2><span>按申请时间、班级与审核状态查询</span></div>
      <form @submit.prevent="queryClicked"><div class="edu-record-fields edu-record-fields-absence"><v-select v-model="query.classId" :items="selectClassList" item-text="className" item-value="id" label="班级" aria-label="班级" dense outlined hide-details color="#d9363e" clearable />
<v-menu v-model="menu1" :close-on-content-click="false" offset-y min-width="auto"><template v-slot:activator="{ on, attrs }"><v-text-field v-model="query.start" label="申请开始日期" aria-label="申请开始日期" readonly dense outlined clearable hide-details color="#d9363e" v-bind="attrs" v-on="on" /></template><v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu>
<v-menu v-model="menu2" :close-on-content-click="false" offset-y min-width="auto"><template v-slot:activator="{ on, attrs }"><v-text-field v-model="query.end" label="申请结束日期" aria-label="申请结束日期" readonly dense outlined clearable hide-details color="#d9363e" v-bind="attrs" v-on="on" /></template><v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu>
<v-select v-model="query.status" :items="statusItems" item-text="statusName" item-value="id" label="请假状态" aria-label="请假状态" dense outlined hide-details color="#d9363e"  /></div>
      <div class="edu-record-filter-bottom"><span>查询当前校区的记录</span><div class="edu-record-filter-actions"><v-btn depressed class="edu-record-query" type="submit" :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form>
    </section>
    <section class="edu-record-list" aria-label="请假申请列表"><div class="edu-record-toolbar"><h2>请假申请</h2><span class="edu-record-count">共 <strong>{{data.total}}</strong> 条</span><span class="edu-record-toolbar-note">查看申请，跟进审核进度</span></div>
      <v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" :mobile-breakpoint="0" class="edu-record-table edu-record-table-absence" disable-pagination hide-default-footer item-key="id" loading-text="正在加载请假申请…" no-data-text="暂无符合条件的请假申请">
        <template v-slot:item.classDate="{item}"><div>{{item.classDate}} <span class="edu-record-secondary">{{item.weekAtName}}</span></div><div class="edu-record-secondary">{{item.timeFrom}}–{{item.timeTo}}</div></template>
        <template v-slot:item.studentName="{item}"><strong class="edu-record-name">{{item.studentName || '—'}}</strong></template>
        <template v-slot:item.status="{item}"><span class="edu-record-status" :class="{'edu-record-status-warning':item.status==='1','edu-record-status-success':item.status==='2','edu-record-status-danger':item.status==='3'}">{{({'1':'待审核','2':'已批准','3':'已拒绝','0':'已取消'})[item.status] || '—'}}</span></template>
        <template v-slot:item.approveAt="{item}">{{item.approveAt || '—'}}</template>
        <template v-slot:item.approveMemo="{item}"><div class="edu-record-wrap">{{item.approveMemo || '—'}}</div></template>
        <template v-slot:item.action="{item}"><div class="edu-record-actions">
					<v-btn :disabled="item.status !== '1'" color="#528367" text small @click="approve(item)">
						同意
					</v-btn>
					<v-btn class="ml-1" :disabled="item.status !=='1'" color="#b94852" text small @click="showRefuseDialog(item)">
						拒绝
					</v-btn>
					<v-btn class="ml-1" color="#718096" text :disabled="item.status =='3' || item.status == '0'" small @click="cancel(item)">
						取消
					</v-btn>

				</div></template>

			</v-data-table><div class="edu-record-pagination"><div class="edu-record-page-total"><span>共 {{data.total}} 条记录</span><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details label="每页数量" aria-label="每页数量" outlined v-model="query.size" color="#d9363e" /></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="5" v-model="query.page" color="#d9363e" /></div></section>
      <absenceRefuse :show="refuseDialog.show" :absenceModel="refuseDialog.absenceModel" @cancel="refuseDialog.show=false" @success="refuseSuccess" />
    </div>
</template>

<script>
	import utils from "../../../config/utils"
	import absenceRefuse from "../../../components/absence_refuse.vue"
	export default {
		name: "class-record-detail-list",
		components:{absenceRefuse},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '请假记录',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '上课时间',
							value: 'classDate',
							sortable: false,	
						},
						{
							text: '请假学员',
							value: 'studentName',
							sortable: false,
						},
						{
							text: '课程',
							value: 'courseName',
							sortable: false,
						},
						{
							text: '班级',
							value: 'className',
							sortable: false,
						},
						{
							text: '申请时间',
							value: 'createAt',
							sortable: false,
										
						},
						{
							text: '状态',
							value: 'status',
							sortable: false,
										
						},
						{
							text: '审核时间',
							value: 'approveAt',
							sortable: false,
										
						},
						{
							text: '审核结果',
							value: 'approveMemo',
							sortable: false,
										
						},
						{
							text: '操作',
							value: 'action',
							align:'center',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "待审核"
					},
					{
						id: "2",
						statusName: "已批准"
					},
					{
						id: "3",
						statusName: "已拒绝"
					},
					{
						id: "0",
						statusName: "已取消"
					},
				],
				
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					shopId: "",
					classId: "",
					status: "",
				},
				refuseDialog:{
					absenceModel:null,
					show:false,
				}
			}
		},
		created() {
			const shopId = utils.getCurrentShopId();
			
			this.getClassListForSelect(shopId);
			
			this.getTableDataList();
		},
		methods: {
			
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			showRefuseDialog(item){
				this.refuseDialog.absenceModel = item;
				this.refuseDialog.show = true;
			},
			refuseSuccess(){
				this.refuseDialog.show = false;
				this.getTableDataList();
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();

				let url = `/edu/absence/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				
				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			approve(item){
				// 批准请假
				const that = this;
				const shopId = utils.getCurrentShopId();
				let url = `/edu/absence/approve/${item.id}`;
				if (shopId) {
					url += `?shopId=${shopId}`;
				}
				
				console.log(url);
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				});
				
			},
			cancel(item){
				// 取消请假
				const that = this;
				const shopId = utils.getCurrentShopId();
				let url = `/edu/absence/cancel/${item.id}`;
				if (shopId) {
					url += `?shopId=${shopId}`;
				}
				
				console.log(url);
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				});
			},
			getClassListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/class/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCourseListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/course/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		

		}
	}
</script>

<style scoped lang="scss">
@import "../../../assets/styles/edu-records.scss";

</style>
